import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

// Import member pages
import MemberDashboard from '../pages/Dashboard';
import MyBookings from '../pages/MyBookings';
import MyProfile from '../pages/MyProfile';
import Support from '../pages/Support';
// import MemberPractitioners from '../pages/Practitioners';

/**
 * MemberRoutes Component
 *
 * Handles all member/client (CLIENT role) routes with /member prefix.
 * Protected routes - only accessible when userRole is CLIENT.
 *
 * Available routes:
 * - /member/dashboard - Member dashboard
 * - /member/my-bookings - View and manage appointments
 * - /member/profile - Member profile and settings
 * - /member/support - Support & Tickets page
 *
 */

export default function MemberRoutes() {
  const location = useLocation();
  const path = location.pathname;

  // Auto-login when a token is handed off via URL (e.g. from the user-web app)
  const urlToken = new URLSearchParams(location.search).get('token');
  if (urlToken) {
    localStorage.setItem('token', urlToken);
    localStorage.setItem('userRole', 'CLIENT');
    window.history.replaceState({}, document.title, location.pathname);
  }

  // Check if user is authenticated
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');

  // Redirect to login if not authenticated
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Redirect to admin dashboard if user is ADMIN (trying to access member routes)
  if (userRole === 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  // Only CLIENT role can access member routes
  if (userRole !== 'CLIENT') {
    return <Navigate to="/" replace />;
  }

  // Determine which page component to render based on current path
  let PageComponent;

  if (path === '/member/dashboard') PageComponent = MemberDashboard;
  else if (path === '/member/my-bookings') PageComponent = MyBookings;
  else if (path === '/member/profile') PageComponent = MyProfile;
  else if (path === '/member/support') PageComponent = Support;
  // Add more routes here as you create member pages
  // else if (path === '/member/practitioners') PageComponent = MemberPractitioners;
  else return <Navigate to="/member/dashboard" replace />; // Default redirect to member dashboard

  return <PageComponent />;
}
